/** H5/H8: chapter 1 -> 2 hook. The quest itself is `ch2-road` in data/story/ch2.ts. TODO-polish: text is rough skeleton copy. */
import { QUESTS } from '../quests';
import { plains256 } from '../zones';
import { CH2 } from './ch2';

export const CH2_ROAD = {
  id: CH2.road,
  title: 'ถนนสายใหม่', // TODO-polish
  goal: 'ไปยังสถานีม้าปลายถนน', // TODO-polish
  /** Where it leads: the exit of plainsExits.ts. */
  station: 'hs-south',
} as const;

/** The next goal once the plains chain (thousand-swords last) is handed in and `ch2-road` is the current quest; else null. */
export const ch2Goal = (p: { quest: { index: number } }): typeof CH2_ROAD | null =>
  plains256() && p.quest.index === QUESTS.findIndex((q) => q.id === CH2.road) ? CH2_ROAD : null;
